// eslint:disable:jsx-no-lambda
import * as React from 'react';
import { MeatballMenu, PromptConfirmationModal, ValidationSummary, ComponentProps, withDropdownMenu, 
  ButtonTertiary, ButtonSecondary} from 'ui/common';
import { LeftPanel } from './panels/left-panel';
import { Permission } from 'ui/common/permission';
import { ButtonCallToAction, DisplayLink, ValidationProps } from 'ui';
import { DropdownMenuContext } from 'ui/common/dropdown-menu/types';
import { useLocation, useSearchParams } from 'react-router-dom';
import { ShareCase } from 'app/area/case/features/share-case/share-case';
import * as navigate from 'app/area/shared/navigation';
import { ConfidentialBanner } from 'ui/info-banner';
import { AuthState, ComplexValue, CompositeKeys, FailedDomainConstraintMetaData, UserMessage, UserType } from 'app/types-shared';
import { routeConstants } from 'app/routes/route-constants';
import { StickyHeader, StickyHeaderButtonContainer } from 'app/shell/components/sticky-header/sticky-header';
import { isValidUrl } from 'app/infrastructure/validation/url';
import { Link as ExternalLink } from 'ui';
import { SharedState } from 'app/types-shared';
import { getHostingPath, isSaveAsDraftEnabled } from 'app/infrastructure/hosting';
import { AddRiskEvaluationInitialValues } from 'app/area/case/features/loss-potential-evaluation/types';
import { AddLossPotentialModal } from 'app/area/case/components/loss-potential/add-loss-potential-evaluation-modal';
import { DefaultContainerProps } from 'app/infrastructure/redux';
import { ChangeCaseStatus, handleChangeStatusUrlParams } from 'app/components/change-case-status/change-case-status';
import { AddNewConnectedCasesWireData, ChangeCaseStatusWireData } from 'app/area/case/features/calls-to-actions/types';
import { AddNewConnectedCasesDropdown } from 'app/components/add-new-cases-dropdown/add-new-connected-cases-dropdown';
import { PortalTargetContext } from 'app/area/case-report/case-listing/portal-provider';
import { useSharedState } from 'app/infrastructure/redux/hooks';
import { UnlockCase } from 'app/area/case/features/unlock-case';
import styles from './case-header-panel.scss';
import { getUrlOpenCase, inStartupDashboard, isCaseViewModalOpen, getPathPrefix, sanitizeRedirectTarget, 
  shouldOpenCaseInModal } from 'app/components/helpers';
import { ConnectedCaseActionTypes, ConnectExistingCases } from 'app/components/connect-existing-cases/connect-existing-cases';
import * as routeUrls from 'app/area/shared/route-urls';
import { HeaderEntryLogMenuItem, useHeaderEntryLog } from './header-entry-log-menu-item';

export interface HeaderPanelProps extends ComponentProps, DefaultContainerProps {
  /**
   * Translations
   */
  textOpenCase?: string;
  textEditCase?: string;
  textDeleteCaseTitle?: string;
  textDeleteCaseDescription?: string;
  textDeleteCaseContinue?: string;
  textDeleteCaseCancel?: string;
  textDuplicateCaseTitle?: string;
  textOpenBowtieTitle?: string;
  textPrintCase?: string;
  textChangeCaseType?: string;
  textConfidentialTitle?: string;
  textConfidentialDescription?: string;
  textConnectCase?: string;
  textSubmit?: string;
  textOpenInSurveyManager?: string;
  textSubmitAndContinue?: string;
  textAddEvaluationTitle?: string;
  textAddEvaluationSubtitle?: string;
  textEvaluationAddItem?: string;
  textEvaluationDescription?: string;
  textEvaluationHideInReport?: string;
  textEvaluationValidFrom?: string;
  textChangeStatus?: string;
  textChangeStatusWarningModalTitle?: string;
  textChangeStatusWarningModalDescription?: string;
  textChangeStatusWarningModalContinue?: string;
  textChangeStatusWarningModalEditCase?: string;
  textChangeStatusWithCaseId?: string;
  textChangeStatusSuccess?: string;
  textChangeStatusForReload?: string;
  textChangeStatusValidationError?: string;
  textAddExisting?: string;
  textAddNew?: string;
  textDisconnect?: string;
  textConnect?: string;
  textNoConnectionToItself?: string;
  textInvalidRangeError?: string;
  titleSearch?: string;
  placeholderSearch?: string;
  textDisconnectWarningModalTitle?: string;
  textDisconnectWarningModalDescription?: string;
  textDisconnectWarningModalContinue?: string;
  textDisconnectWarningModalCancel?: string;
  validateCaseId: (caseId: number) => boolean;
  favouriteComponent?: React.ComponentType;
  connectedCasesIds?: number[];
  connectedCasesPendingDeleteIds?: number[];
  textSaveAsDraft?: string;
  textEditAction?: string;
  editActionEntityPath?: string;
  involvedPersonPath?: CompositeKeys;
  /**
   *
   * Content to include in the right panel
   */
  url?: string;
  contentRight?: any;
  onEditDocument?: () => void;
  onDeleteDocument?: () => void;
  onDuplicateDocument?: () => void;
  onLoadBowtie?: () => void;
  onChangeCaseType?: () => void;
  onConnectCase?: () => void;
  onSubmitDocument: (continueEditing?: boolean) => void;
  onCloseDocument: () => void;
  onLoadPermissions: (caseNumber: number) => void;
  onSaveAsDraft?: () => void;
  permissionsLoaded?: boolean;
  disableAllEntityOperations?: boolean;
  enabledEntityOperations?: { edit: boolean; delete: boolean; bowtie: boolean;
    lossPotential: boolean; residualLossPotential: boolean; };
  validation?: ValidationProps;
  readOnly?: boolean;
  caseId?: number;
  translate?: { [key: string]: string };
  confidential?: ComplexValue<boolean>;
  enableStickyHeader?: boolean;
  urlFromTemplateString?: string;
  sharedState: SharedState;
  onCopyRiskEvaluation?: (riskMatrixInstance: number, instanceCopyCmd: number, initialValues: AddRiskEvaluationInitialValues,
    newWindow?: boolean) => void;
  callsToActions?: (caseId: number) => { changeStatus: ChangeCaseStatusWireData; addNewConnectedCases: AddNewConnectedCasesWireData[];
    editAccess: boolean; deleteAccess: boolean; bowtieSupported: boolean; entryLogSupported?: boolean;
    lossPotentialSupported: boolean; residualLossPotential: boolean; surveyManagerSupported: boolean;
   };
  onChangeCaseStatus: (caseId: number, status: ComplexValue<number>) =>
    {userMessages: string | UserMessage[]; warnings: FailedDomainConstraintMetaData[]; validationErrors: string[]};
  changingCaseStatus?: boolean;
  reloadOnCallsToActions?: boolean;
  params: {id: string; dashboardType: string; favouriteId: string; bowtieCaseId: string};
  onChangeCaseConnection: ({ caseId, connectedCaseId, connectionTypeId, currentConnectedCases,
    type, allowWarnings }: {
      caseId: number;
      connectedCaseId: number;
      connectionTypeId: number;
      currentConnectedCases: number[];
      allowWarnings: boolean;
      type: ConnectedCaseActionTypes;
    }) => {
      userMessages: string | UserMessage[]; 
      warnings: FailedDomainConstraintMetaData[];
      validationErrors: string[];
    };
}

const HeaderPanel: React.FC<React.PropsWithChildren<HeaderPanelProps>> = (props) => {
  const {
    componentId,
    className,
    validation,
    contentRight,
    disableAllEntityOperations,
    enableStickyHeader
  } = props;

  const leftPanelContents = <LeftPanel {...props} />;

  return <>
    <StickyHeader id={componentId} disabled={!enableStickyHeader} rightSideContent={!disableAllEntityOperations && contentRight}
      className={`${className} ${styles.headerWrapper} ${enableStickyHeader ? styles.headerSticky : ''} header-panel`}>
      <span className={styles.leftPanelContents}>{leftPanelContents}</span>
    </StickyHeader>
    <div className={styles.validation}>
      <ValidationSummary validationError={validation} />
    </div>
  </>;
};

interface PrintLinkProps extends DropdownMenuContext {
  text: string;
  url: string;
}

export const PrintLink: any = withDropdownMenu((props: PrintLinkProps) => {
  const onPrintCase = () => {
    const { handleDropdownHide, url } = props;
    handleDropdownHide && handleDropdownHide();
    navigate.toPrintCaseView(url);
  };
  return <li>
    <button type="button" className="dropdown-item" onClick={onPrintCase}>
      {props.text}
    </button>
  </li>;
});

const ReadModeRightContent = (props: HeaderPanelProps, visibilityConfiguration: HeaderVisibilityConfiguration = {}) => {
  
  const location = useLocation();
  const currentPath = location.pathname;
  const [searchParams, setSearchParams] = useSearchParams();
  const panelConfig = visibilityConfiguration.panel;
  const meatballMenuConfig = visibilityConfiguration.meatballMenu;
  const { portalTarget } = React.useContext(PortalTargetContext);
  const caseURL = routeConstants.caseViewFor(props.caseId);
  const searchString = searchParams?.toString() ? `?${searchParams?.toString()}` : '';
    
  const caseEditUrl = isCaseViewModalOpen() ? `${currentPath}${routeConstants.edit}${searchString}` :
   (shouldOpenCaseInModal(!props.params?.id) ? 
    `${getPathPrefix()}${currentPath}${routeConstants.caseEditFor(props.caseId)}${searchString}` :
  `${routeConstants.caseEditFor(props.caseId)}${searchString}`);

  const caseDuplicateUrl = isCaseViewModalOpen() ? `${currentPath}${routeConstants.duplicate}${searchString}` :
   (shouldOpenCaseInModal(!props.params?.id) ? 
    `${getPathPrefix()}${currentPath}${routeConstants.caseDuplicateFor(props.caseId)}${searchString}` :
  `${routeConstants.caseDuplicateFor(props.caseId)}${searchString}`);

  const editActionUrl = props.editActionEntityPath ? (
    isCaseViewModalOpen() ? `${currentPath}${props.editActionEntityPath}${routeConstants.edit}${searchString}` :
    (shouldOpenCaseInModal(!props.params?.id) ?
      `${getPathPrefix()}${currentPath}${routeUrls.toCaseEdit(props.caseId, props.editActionEntityPath)}${searchString}` :
      `${routeUrls.toCaseEdit(props.caseId, props.editActionEntityPath)}${searchString}`)
  ) : '';
  
  const [callsToActions, setCallsToActions] = React.useState(undefined);
  const entryLog = useHeaderEntryLog(props.caseId, props.involvedPersonPath);

  const onExpandMenu = async () => {
    // Both are set together, so the menu items appear at once and none of them changes afterwards
    const [getCallsToActions, openEntry] = await Promise.all([props.callsToActions?.(props.caseId), entryLog.loadOpenEntry?.()]);
    setCallsToActions(getCallsToActions);
    if (openEntry !== undefined) {
      entryLog.setOpenEntryPath(openEntry);
    }
  };
  
  React.useEffect(() => {
    handleChangeStatusUrlParams(props, searchParams, setSearchParams);
  }, []);

  const sharedState = useSharedState();
  const allowForCurrentUser = sharedState?.userType?.v !== UserType.basic;

  const handleDelete = () => {
    props.onDeleteDocument();
    if(isCaseViewModalOpen()) {
      if(inStartupDashboard()) {
        navigate.toStartupView();
        window.location.reload();
        return;
      }
      const targetPath = location.pathname.replace(/\/case\/\d+$/, '');
      const fullTarget = `${targetPath}${location.search}`;
      window.location.href = sanitizeRedirectTarget(fullTarget); // full page reload
    }
  };
  
  return <>
  <Permission requireAll="edit" permissions={props.enabledEntityOperations}>
    {panelConfig?.edit && 
      <StickyHeaderButtonContainer>
        <DisplayLink url={caseEditUrl} urlHrefNewTabOverride={routeConstants.caseEditFor(props.caseId)} 
          navigateToUrlForNewTab={true}>
          <ButtonCallToAction id="editcasebutton"
            onClick={props.onEditDocument}>
            {props.textEditCase}
          </ButtonCallToAction>
        </DisplayLink>
      </StickyHeaderButtonContainer>}
  </Permission>

    {meatballMenuConfig && <MeatballMenu onExpandMenu={onExpandMenu} portalTarget={portalTarget?.current}>
      {callsToActions?.editAccess && meatballMenuConfig.editAction && editActionUrl &&
        <DisplayLink url={editActionUrl} className="btn dropdown-item"
          urlHrefNewTabOverride={routeUrls.toCaseEdit(props.caseId, props.editActionEntityPath)}
          navigateToUrlForNewTab={true}>
          {props.textEditAction}
        </DisplayLink>}

      {callsToActions?.editAccess && meatballMenuConfig.edit && caseEditUrl &&
        <DisplayLink url={caseEditUrl} className="btn dropdown-item"
          urlHrefNewTabOverride={routeConstants.caseEditFor(props.caseId)} 
          navigateToUrlForNewTab={true}>
          {props.textEditCase}
        </DisplayLink>}

      {!!props.involvedPersonPath &&
        <HeaderEntryLogMenuItem caseId={props.caseId} involvedPersonPath={props.involvedPersonPath} callsToActions={callsToActions}
          entryLog={entryLog} />}

      {callsToActions?.lossPotentialSupported && meatballMenuConfig.lossPotential && allowForCurrentUser &&
        <AddLossPotentialModal {...props} textValidFrom={props.textEvaluationValidFrom}
          textEvaluationDescription={props.textEvaluationDescription} textEvaluationHideInReport={props.textEvaluationHideInReport}
          textAddEvaluationSubtitle={`${props.textAddEvaluationSubtitle} ${' #'}${props.caseId}`}
          textAddItem={props.textAddEvaluationTitle} textAdd={props.textEvaluationAddItem} addButtonStyle='dropdownItem'
          allowCopyFromOtherInstance={callsToActions?.residualLossPotential}
          allowCopyEvaluationToResidual={callsToActions?.residualLossPotential} />}

      {!!callsToActions?.addNewConnectedCases?.length  && allowForCurrentUser &&
        callsToActions?.addNewConnectedCases?.map((addNewConnectedCase: AddNewConnectedCasesWireData, index: number) => {
          return <AddNewConnectedCasesDropdown
            entityId={props.caseId}
            addNewConnectedCaseButtons={addNewConnectedCase.newCaseButtons}
            textLabelMenu={addNewConnectedCase.label}
            key={index}
            {...props} />;
        })}

      {!!callsToActions?.changeStatus && callsToActions?.editAccess && allowForCurrentUser &&
        <ChangeCaseStatus
          caseId={props.caseId} changeCaseStatusOptions={callsToActions.changeStatus}
          changeCaseStatus={props.onChangeCaseStatus}
          textChangeStatus={props.textChangeStatus} textWarningModalTitle={props.textChangeStatusWarningModalTitle}
          textWarningModalDescription={props.textChangeStatusWarningModalDescription}
          textWarningModalContinue={props.textChangeStatusWarningModalContinue}
          textWarningModalEditCase={props.textChangeStatusWarningModalEditCase}
          textChangeStatusSuccess={props.textChangeStatusSuccess}
          textChangeStatusWithCaseId={props.textChangeStatusWithCaseId}
          textChangeStatusForReload={props.textChangeStatusForReload}
          textChangeStatusValidationError={props.textChangeStatusValidationError}
          reloadOnChangeStatus={isCaseViewModalOpen() ? false : props.reloadOnCallsToActions}
          allowWarnings={false} 
          caseEditUrl={caseEditUrl}
          changingCaseStatus={props.changingCaseStatus}/>}

      {(callsToActions?.connectExistingCases && callsToActions?.editAccess && props.favouriteComponent) &&
        <ConnectExistingCases
          {...props}
          caseId={props.caseId}
          options={callsToActions.connectExistingCases?.options}
          label={callsToActions.connectExistingCases?.label}
          allowWarnings={false}
          textWarningModalTitle={props.textChangeStatusWarningModalTitle}
          textWarningModalDescription={props.textChangeStatusWarningModalDescription}
          textWarningModalContinue={props.textChangeStatusWarningModalContinue}
          textWarningModalEditCase={props.textChangeStatusWarningModalEditCase}
          textChangeStatusSuccess={props.textChangeStatusSuccess}
          textWarningModalCancel={props.textDeleteCaseCancel}
          textDisconnectWarningModalTitle={props.textDisconnectWarningModalTitle}
          textDisconnectWarningModalDescription={props.textDisconnectWarningModalDescription}
          textDisconnectWarningModalContinue={props.textDisconnectWarningModalContinue}
          textDisconnectWarningModalCancel={props.textDisconnectWarningModalCancel}
          disconnectWarning
        />
      }

      {meatballMenuConfig.open && 
        caseURL &&   
          <DisplayLink value={props.caseId} 
            url={getUrlOpenCase(props.caseId, currentPath, searchParams)} 
            className="btn dropdown-item">{props.textOpenCase}
          </DisplayLink>}

      {callsToActions?.bowtieSupported && meatballMenuConfig.bowtie &&
        <button type="button" className="dropdown-item" onClick={props.onLoadBowtie}>
          {props.textOpenBowtieTitle}
        </button>}

      {callsToActions?.surveyManagerSupported && props.sharedState.access &&
        props.sharedState.access.surveyManager.send &&
        isValidUrl(props.urlFromTemplateString) &&
        <ExternalLink url={props.urlFromTemplateString} linkText={props.textOpenInSurveyManager} className={'dropdown-item'} />}

      {callsToActions?.editAccess && meatballMenuConfig.duplicate &&
        <DisplayLink url={caseDuplicateUrl} urlHrefNewTabOverride={routeConstants.caseDuplicateFor(props.caseId)}
          navigateToUrlForNewTab={true} className={`btn dropdown-item ${styles.duplicateCaseMenuItem}`}>
          <button type="button" className="dropdown-item" onClick={props.onDuplicateDocument}>
            {props.textDuplicateCaseTitle}
          </button>
        </DisplayLink>}

      {callsToActions?.editAccess && meatballMenuConfig.share &&
        <ShareCase {...props}>
          {
            ({ onOpen }) => <button type="button" className="dropdown-item" onClick={onOpen}>{props.translate.share_case}</button>
          }
        </ShareCase>
      }

      {meatballMenuConfig.print &&
        <PrintLink text={props.textPrintCase} url={(getHostingPath() || '') + caseURL} />}

      {callsToActions?.deleteAccess && meatballMenuConfig.delete &&
        <PromptConfirmationModal
          title={props.textDeleteCaseTitle}
          description={props.textDeleteCaseDescription}
          continueText={props.textDeleteCaseContinue}
          cancelText={props.textDeleteCaseCancel}
          onContinue={handleDelete}>
          <button type="button" className="dropdown-item">{props.textDeleteCaseTitle}</button>
        </PromptConfirmationModal>
      }

      {callsToActions?.unlockAccess && meatballMenuConfig.unlockAccess &&
        <UnlockCase {...props}>
          {
            ({ onOpen }) => <button type="button" className="dropdown-item" onClick={onOpen}>
              {props.translate.unlock_case}
            </button>
          }
        </UnlockCase>
      }
    </MeatballMenu>
    }
  </>;
};

export type HeaderVisibilityConfiguration = {
  panel?: {
    edit?: boolean;
  };
  meatballMenu?: {
    open?: boolean;
    edit?: boolean;
    delete?: boolean;
    duplicate?: boolean;
    bowtie?: boolean;
    changeCaseType?: boolean;
    share?: boolean;
    print?: boolean;
    submitAndContinue?: boolean;
    lossPotential?: boolean;
    residualLossPotential?: boolean;
    unlockAccess?: boolean;
    editAction?: boolean;
    entryLog?: boolean;
  };
};

const EditModeRightContent = (props: HeaderPanelProps, visibilityConfiguration: HeaderVisibilityConfiguration = {}) => {
  const meatballMenuConfig = visibilityConfiguration.meatballMenu;
  const shouldDisplayChangeCaseType = !props.readOnly && meatballMenuConfig?.changeCaseType;
  const shouldDisplayMeatballMenu = shouldDisplayChangeCaseType || meatballMenuConfig?.submitAndContinue;
  const sharedState = useSharedState();
  const isAnonymous = sharedState.authState === AuthState.Anonymous;
  
  const onSubmitAndContinue = () => {
    props.onSubmitDocument && props.onSubmitDocument(true);
  };
  const onSubmitDocument = () => {
    props.onSubmitDocument && props.onSubmitDocument(false);
  };

  const onSaveAsDraft = (e: React.SyntheticEvent) => {
    e.preventDefault();
    props.onSaveAsDraft?.();
  };

  const shouldDisplaySaveAsDraft = isSaveAsDraftEnabled() && !props.caseId;

  return (
    <>
      <StickyHeaderButtonContainer>
        <ButtonTertiary onClick={props.onCloseDocument}>
          {props.textDeleteCaseCancel}
        </ButtonTertiary>
        {shouldDisplaySaveAsDraft && isAnonymous && (
          <ButtonSecondary onClick={onSaveAsDraft} classNames={styles.saveAsDraftButton}>
            {props.textSaveAsDraft}
          </ButtonSecondary>
        )}
        <ButtonCallToAction id="form-submit" onClick={onSubmitDocument}>
          {props.textSubmit}
        </ButtonCallToAction>
      </StickyHeaderButtonContainer>
      {shouldDisplayMeatballMenu && (
        <MeatballMenu>
          {shouldDisplayChangeCaseType && (
            <button
              type="button"
              className="dropdown-item"
              onClick={props.onChangeCaseType}
            >
              {props.textChangeCaseType}
            </button>
          )}
          {shouldDisplaySaveAsDraft && !isAnonymous && (
            <button
              type="button"
              className="dropdown-item"
              onClick={onSaveAsDraft}
            >
              {props.textSaveAsDraft}
            </button>
          )}
          {meatballMenuConfig.submitAndContinue && (
            <button
              type="button"
              className="dropdown-item"
              onClick={onSubmitAndContinue}
            >
              {props.textSubmitAndContinue}
            </button>
          )}
        </MeatballMenu>
      )}
    </>
  );
};

export const ReadHeaderPanel = (props: any) => {
  const isConfidential = props.confidential && props.confidential.valueObject && props.confidential.valueObject.value;
  return (
    <>
      {!!isConfidential &&
        <ConfidentialBanner textTitle={props.textConfidentialTitle} textDescription={props.textConfidentialDescription} />}
      <HeaderPanel contentRight={ReadModeRightContent(props, props.headerVisibilityConfiguration)} {...props} />
    </>);
};

export const EditHeaderPanel = (props: any) => {
  return <HeaderPanel contentRight={EditModeRightContent(props, props.headerVisibilityConfiguration)} {...props} />;
};
